import React, { FC } from 'react'

import { Typography, FNOLPageWrapper, useTranslate, FNOLButton } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { useFNOLStyles } from '../shared/styles/useStyles'
import { TRANSLATIONS as T } from '../../../constants'

const PageCaseOfAccident: FC<CommonPageProps> = ({ service, currentState }) => {
  const FNOLClasses = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.caseOfAccident`)
  const { send } = service

  const itemSelect = ({ eventName, label }: { eventName: Events; label: string }) => (
    <FNOLButton
      key={label}
      testId={label}
      handleClick={() => send({ type: eventName, state: currentState })}
      buttonText={t(label)}
    />
  )

  const eventItems = [
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.notGiveUp' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.rearEndCollision' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.backing' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.overtaking' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.parking' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.oncoming' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.leftTurn' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.fieldChange' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.chainCollision' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.roundabout' },
    { eventName: Events.FNOL_COLLISION_REGISTRATION_NUM, label: 'buttons.other' },
  ]
  const ItemsList = () => <>{eventItems.map((item) => itemSelect(item))}</>

  const Content = () => (
    <>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <ItemsList />
    </>
  )

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={50}>
      <Content />
    </FNOLPageWrapper>
  )
}

export default PageCaseOfAccident
